<template>
  <div id="setting" class="grid-map-menu-body">
    <component
      :is="scrollbarTag"
      class="grid-map-scroll-area--customizer pt-4 pb-6"
      :settings="settings"
    >
      <vs-collapse>
        <vs-collapse-item open>
          <div
            slot="header"
            class="header-label aisea-text-16-300-white"
            id="map-style-collapse-item-header-map-style"
          >
            地図の種類
          </div>
          <layer-card
            :updateMapStyle="updateMapStyle"
            :displayMapStyle="displayMapStyle"
          />
        </vs-collapse-item>
      </vs-collapse>
      <vs-collapse>
        <vs-collapse-item open>
          <div
            slot="header"
            class="header-label aisea-text-16-300-white"
            id="map-style-collapse-item-header-default-position"
          >
            初期表示位置
          </div>
          <position-card :updateDefaultPosition="updateDefaultPosition" />
        </vs-collapse-item>
      </vs-collapse>
    </component>
  </div>
</template>

<script>
/**
 * 【右メニュー】設定メニューを描画するためのコンポーネント
 * @parent O.RightMenuBase
 */
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import LayerCard from "@/components/molecules/LayerCard";
import PositionCard from "@/components/molecules/PositionCard.vue";
import FireStoreService from "@/services/fireStoreService";
import { createNamespacedHelpers } from "vuex";
import { LayerMixin } from "@/mixins";

const { mapState: mapStateOfGridMap, mapMutations: mapMutationsOfGridMap } =
  createNamespacedHelpers("gridMap");
const { mapGetters: mapGettersOfMapSetting } =
  createNamespacedHelpers("mapSetting");

export default {
  name: "O.Settings",
  mixins: [LayerMixin],
  components: {
    VuePerfectScrollbar,
    LayerCard,
    PositionCard,
  },
  props: {
    /** スクロールの設定 */
    settings: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapStateOfGridMap({
      activeSidebarForGrid: (state) => state.activeSidebarForGrid,
      allGridMapSettings: (state) => state.allGridMapSettings,
    }),
    ...mapGettersOfMapSetting(["getCenterForGrid", "getZoomForGrid"]),
    displayMapStyle() {
      const value = this.activeSidebarForGrid;
      // 設定メニューを閉じたときの処理
      if (!value.mapId || !this.allGridMapSettings) {
        // "M.LayerCard"内でdisplayMapStyleの変更を検知するためにメニューを閉じた際に明示的にdisplayMapStyleを0にする。
        return 0;
      }
      const mapId = value.mapId;
      const mapStyle = this.allGridMapSettings.find(
        (setting) => setting.map_id === mapId,
      ).map_style;
      return this.mapStyleList.find((style) => style.url === mapStyle).id;
    },
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
  },
  async mounted() {
    const mapId = this.activeSidebarForGrid.mapId;
    this.center = this.getCenterForGrid(mapId);
    this.zoom = this.getZoomForGrid(mapId);
  },
  methods: {
    ...mapMutationsOfGridMap(["UPDATE_GRID_MAP_SETTINGS"]),
    /** 地図の種類を更新 */
    async updateMapStyle(layer) {
      if (!layer) return;
      const mapId = this.activeSidebarForGrid.mapId;
      // store(vuex)更新
      this.UPDATE_GRID_MAP_SETTINGS({ map_id: mapId, map_style: layer.url });
      // firestore更新
      await FireStoreService.setGridMapSettings(mapId, {
        map_style: layer.url,
      });
    },
    /** 初期表示位置を更新 */
    async updateDefaultPosition() {
      const mapId = this.activeSidebarForGrid.mapId;
      let center = this.getCenterForGrid(mapId);
      let defaultPosition = {
        center: [center.lng, center.lat],
        zoom: this.getZoomForGrid(mapId),
      };
      // store(vuex)更新
      this.UPDATE_GRID_MAP_SETTINGS({
        map_id: mapId,
        default_position: defaultPosition,
        last_zoom: null,
      });
      // firestore更新
      await FireStoreService.setGridMapSettings(mapId, {
        default_position: defaultPosition,
        last_zoom: null,
      });
      this.$vs.notify({
        title: "初期表示の設定",
        text: "現在の状態を初期表示地点として保存しました",
        color: "success",
        position: "top-center",
      });
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/aisea/mixin";

#setting.grid-map-menu-body {
  .vs-collapse {
    padding: 0 20px 20px;
  }
  .vs-collapse-item--content {
    border-radius: 5px;
  }
  .header-label {
    color: #f2f2f2;
  }

  span.icon-header {
    .vs-icon {
      @include image-button("sm");
      background-color: $aisea-dark-blue;
      border-radius: 3px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background-color: #595d69;
      }

      &:active {
        background-color: #8b8e97;
      }
    }
  }
}
</style>
